<template>
  <div class="lltlastrela between">
    <div class="lastrelaleft">
      <div class="lal_title between">
        <div class="coltit">最新咨询</div>
        <div class="mo">更多></div>
      </div>
      <div class="lal_list">
        <div class="lal_item" v-for="(item, index) in 2" :key="index">
          <div class="cont_w flex_start ellipsis">
            <img src="~assets/question/w.png" />

            {{
              `好，我想离婚了，我想起诉离婚，我也不懂，` | toEllipsisFilter(40)
            }}
          </div>
          <div class="cont_d flex_start">
            <img src="~assets/question/d.png" />
            {{
              `无法协议离婚的，应向法院起诉离婚。法院判决离婚的标准是夫妻感情是否确已破裂，如达到这一标准的，一般情况下会判离婚。婚姻法第三十`
                | toEllipsisFilter(99)
            }}
          </div>
          <div class="cont_bom between">
            <div class="con_left flex_start">
              <div>
                <img src="~assets/base/small_rentou.png" />
                <img src="~assets/base/small_rentou.png" class="m_15" />
                <img src="~assets/base/small_rentou.png" class="m_15" />
              </div>
              <div class="FontSize14"><span>3</span>位律师回复</div>
            </div>
            <div class="cb_right"><span>100</span> 次浏览</div>
          </div>
        </div>
      </div>
    </div>
    <div class="lastrelaright">
      <div class="coltit">最新知识</div>
      <ul class="mt20">
        <li class="ellipsis" v-for="item in list.slice(0,9)" :key="item">
          {{item.title}}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
	data(){
		return{
		list:[]	
		}
	},
created() {
	this.$http.home.newslist().then( res => {
		this.list = res.data.data
	})
}
};
</script>

<style lang="scss" scoped>
.lltlastrela {
  width: 1200px;
  padding: 50px 0;
  margin: 0 auto;
  align-items: flex-start;
  .coltit {
    font-size: 24px;
    color: #333333;
  }
  .lastrelaleft {
    width: 814px;
    .lal_title {
      .mo {
        font-size: 14px;
        color: #666666;
        cursor: pointer;
      }
    }
    .lal_list {
      .lal_item {
        padding: 29px 0;
        border-bottom: 1px solid rgba($color: #9999, $alpha: 0.4);
        &:last-child {
          border-bottom: none;
          padding-bottom: 0;
        }
        .m_15 {
          margin-left: -15px;
        }
        .cont_w,
        .cont_d {
          align-items: flex-start;
          img {
            width: 26px;
            height: 26px;
            margin-right: 16px;
          }
        }
        .cont_w {
          font-size: 16px;
          color: #333;
        }
        .cont_d {
          margin-top: 18px;
          font-size: 14px;
          color: #999;
        }
        .cont_bom {
          margin-top: 18px;
          font-size: 12px;
          color: #999;
          .con_left {
            img {
              width: 40px;
              height: 40px;
            }
            span {
              color: #0465ea;
              margin-left: 10px;
            }
          }
          .cb_right {
            font-size: 12px;
            color: #999999;
            span {
              color: #0465ea;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
  .lastrelaright {
    width: 306px;
    ul {
      color: #333;
      font-size: 14px;
      li {
        line-height: 38px;
        cursor: pointer;
        &:hover {
          color: #0465ea;
        }
      }
    }
  }
}
</style>